import $ from "jquery";
import App from "../src/App";
import Swiper from "swiper";
import "swiper/scss";
import "../components/slide-three-images";
import { Navigation } from "swiper/modules";

$(".js-tab-title").click(function () {
  let classToShow = $(this).data("content");
  showProperContent(".js-tab-title", classToShow);
  showProperContent(".js-content-card", classToShow);
  showProperContent(".js-photo", classToShow);
});

const showProperContent = (allElementsClass, classToShow) => {
  $(allElementsClass).each(function () {
    $(this).hasClass(classToShow) ? $(this).addClass("active") : $(this).removeClass("active");
  });
};

const accommodationMobileSlider = new Swiper(".js-accommodation-slider-mobile", {
  modules: [Navigation],
  slidesPerView: 1,
  spaceBetween: 10,
  navigation: {
    nextEl: ".js-swiper-next",
    prevEl: ".js-swiper-prev",
  },
});
